"use client"

import { useState, useEffect } from "react";
import { Card, Table } from "react-bootstrap";

/**
 * UserActiveSection is a React functional component that renders a card component
 * displaying information about active users. The card consists of a header, a title,
 * and a text body. The header displays "Active Users", while the title and text body
 * provide additional context and information to the user.
 */

const UserActiveSection = ({ data }) => {

    const [activeUsers, setActiveUsers] = useState([]);
    const [isDarkMode, setIsDarkMode] = useState(false);

    useEffect(() => {
        const checkDarkMode = () => {
            const htmlElement = document.querySelector("html");
            setIsDarkMode(htmlElement.classList.contains("dark") || localStorage.getItem("theme") === "dark");
        };
        checkDarkMode();
    }, []);

    useEffect(() => {
        // Set active users from data.data array
        if (data && data.data && Array.isArray(data.data)) {
            setActiveUsers(data.data);
        } else {
            setActiveUsers([]);
        }
    }, [data]);

    return (
        <Card className="border-0">
            <Card.Header className={`bg-primary ${isDarkMode ? 'text-white' : 'text-white'}`}>Active Users</Card.Header>
            <Card.Body className="m-0 p-0" style={{ overflow: "auto", maxHeight: "400px" }}>
                <Table className={`table table-hover table-striped m-0 p-0 ${isDarkMode ? 'table-dark' : ''}`}>
                    <thead>
                        <tr className="sticky-top">
                            <th scope="col" width="1%">No</th>
                            <th scope="col" width="35%">Nama</th>
                            <th scope="col" width="20%">Email</th>
                            <th scope="col" width="20%">Instansi</th>
                            <th scope="col" width="15%">No. Telepon</th>
                            <th scope="col" width="30%">Tanggal Daftar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {activeUsers.length === 0 && <tr><td colSpan={6} className="text-center">Tidak ada data</td></tr>}
                        {activeUsers.length > 0 && activeUsers.map((item, index) => (
                            <tr key={index}>
                                <td><span>{index + 1}</span></td>
                                <td><span>{item.name}</span></td>
                                <td><span>{item.email}</span></td>
                                <td><span>{item.organization}</span></td>
                                <td><span>{item.phone}</span></td>
                                <td><span>{item.registration_date}</span></td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
}

export default UserActiveSection